define('helper-content-getTrainingMap',['exports', './content--get-entity.es', './entity--is-quiz-game-page.es'], function (exports, _contentGetEntity, _entityIsQuizGamePage) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _contentGetEntity2 = _interopRequireDefault(_contentGetEntity);

    var _entityIsQuizGamePage2 = _interopRequireDefault(_entityIsQuizGamePage);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    exports.default = function (trainingEntities) {
        var arr = [],
            item = null,
            map = [];

        if (!Array.isArray(trainingEntities) || !trainingEntities.length || !trainingEntities[0].contentEntityId) {
            return map;
        }

        (function f(entities, id) {
            var nextID = '',
                childID = '',
                entity = (0, _contentGetEntity2.default)(id, trainingEntities),
                content = entity && entity.contentEntity ? entity.contentEntity : null,
                getNextID = function getNextID(arr, indx) {
                var no = indx + 1 || 0;

                if (Array.isArray(arr) && arr.length > no) {
                    return arr[no].contentEntityId;
                }

                return '';
            },
                objInArray = function objInArray(obj, arr) {
                var i = Array.isArray(arr) ? arr.length : 0;

                while (i--) {
                    if (arr[i].id === obj.id && arr[i].value === obj.value) {
                        return true;
                    }
                }

                return false;
            };

            if (!content) {
                return;
            }

            if (content.naviTargetId) {

                item = {
                    id: id,
                    value: content.naviTargetId
                };

                if (!objInArray(item, arr)) {
                    arr.push(item);
                    f(entities, content.naviTargetId);
                }
            } else {

                if (Array.isArray(entity.children) && entity.children.length && entity.hasOwnProperty('typeId') && entity.typeId !== 19 && !(0, _entityIsQuizGamePage2.default)(entity)) {

                    if (entity.children[0].hasOwnProperty('contentEntityId')) {
                        childID = entity.children[0].contentEntityId;
                    }

                    if (childID) {

                        item = {
                            id: id,
                            value: childID
                        };

                        if (!objInArray(item, arr)) {
                            arr.push(item);
                            f(entity.children, childID);
                        }
                    }
                }

                if (entities.indexOf(entity) < entities.length) {

                    nextID = getNextID(entities, entities.indexOf(entity));

                    item = {
                        id: id,
                        value: nextID
                    };

                    if (!objInArray(item, arr)) {
                        arr.push(item);
                        f(entities, nextID);
                    }
                }
            }

            if (Array.isArray(entity.answers) && entity.answers.length) {

                entity.answers.forEach(function (answer) {
                    nextID = answer && answer.naviTargetId ? answer.naviTargetId : '';

                    item = {
                        id: id,
                        value: nextID
                    };

                    if (!objInArray(item, arr)) {
                        arr.push(item);
                        f(trainingEntities, nextID);
                    }
                });
            }
        })(trainingEntities, trainingEntities[0].contentEntityId);

        arr.forEach(function (a) {
            if (map.indexOf(a.id) === -1) {
                map.push(a.id);
            }
        });

        return map;
    };
});
